/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CatalogActivityDailyRowDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const CatalogActivityDailyRowDTOActivityEnum = {
    PoolAdd: 'POOL_ADD',
    InventoryAdd: 'INVENTORY_ADD',
    InventoryArrived: 'INVENTORY_ARRIVED',
    InventoryDelete: 'INVENTORY_DELETE',
    PriceUpdate: 'PRICE_UPDATE',
    InventoryPassive: 'INVENTORY_PASSIVE',
    AddFailure: 'ADD_FAILURE',
    AddActivatedLater: 'ADD_ACTIVATED_LATER'
};
/**
 * Check if a given object implements the CatalogActivityDailyRowDTO interface.
 */
export function instanceOfCatalogActivityDailyRowDTO(value) {
    return true;
}
export function CatalogActivityDailyRowDTOFromJSON(json) {
    return CatalogActivityDailyRowDTOFromJSONTyped(json, false);
}
export function CatalogActivityDailyRowDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'activity': json['activity'] == null ? undefined : json['activity'],
        'source': json['source'] == null ? undefined : json['source'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'filterId': json['filterId'] == null ? undefined : json['filterId'],
        'filterName': json['filterName'] == null ? undefined : json['filterName'],
        'requested': json['requested'] == null ? undefined : json['requested'],
        'succeeded': json['succeeded'] == null ? undefined : json['succeeded'],
        'failed': json['failed'] == null ? undefined : json['failed'],
    };
}
export function CatalogActivityDailyRowDTOToJSON(json) {
    return CatalogActivityDailyRowDTOToJSONTyped(json, false);
}
export function CatalogActivityDailyRowDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'activity': value['activity'],
        'source': value['source'],
        'detail': value['detail'],
        'filterId': value['filterId'],
        'filterName': value['filterName'],
        'requested': value['requested'],
        'succeeded': value['succeeded'],
        'failed': value['failed'],
    };
}
